export const LIBRARY_PAGE_SIZE = 24;
export function explorerPage<F, D>(folders: F[], decks: D[], requestedPage: number) {
  const total=folders.length+decks.length;
  const totalPages=Math.max(1,Math.ceil(total/LIBRARY_PAGE_SIZE));
  const page=Math.max(0,Math.min(requestedPage,totalPages-1));
  const start=page*LIBRARY_PAGE_SIZE,end=start+LIBRARY_PAGE_SIZE;
  return {page,total,totalPages,folders:folders.slice(start,end),decks:decks.slice(Math.max(0,start-folders.length),Math.max(0,end-folders.length))};
}
